import { render, staticRenderFns } from "./detaliPageConToitet.vue?vue&type=template&id=21d84c68&scoped=true"
import script from "./detaliPageConToitet.vue?vue&type=script&lang=js"
export * from "./detaliPageConToitet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d84c68",
  null
  
)

export default component.exports